import { Box } from '@mui/material';
import React from 'react';

interface PageAreaProps {
  children: React.ReactNode
  backgroundColor?: string;
}


function PageArea(props: PageAreaProps) {
  return (
    <Box sx={{
      padding: { md: '32px', xs: '16px' },
      backgroundColor: props.backgroundColor || 'background.default',
      flex: 1,
      minWidth: 0,
    }}>
      {props.children}
    </Box>
  );
}

export default PageArea;